import { r as registerInstance, h, H as Host, g as getElement } from './index-aaa15b55.js';
import { q as escape, t as textIsValid, D as DEFAULT_DECIMAL_CASES, z as getDecimalPlaces } from './logger-faaf508a.js';

const fcisDropdownCss = "fcis-dropdown{display:block}.fcis-dropdown{margin-top:var(--wb-spacing-xs)}.fcis-dropdown--with-tooltip .fcis-dropdown__input{padding-right:5rem}.fcis-dropdown--with-tooltip wb-icon[name*=caret-down]{right:3rem !important}.fcis-dropdown__tooltip{right:1rem;position:absolute;top:1rem;display:-ms-inline-flexbox;display:inline-flex;-ms-flex-item-align:center;align-self:center}";

const FcisDropdown = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.renderNumber = 0;
  }
  onInputChange() {
    this.renderNumber++;
    this.selectElement.value = this.input.value.value;
  }
  render() {
    const { info, label, id, values, message } = this.input;
    return (h("wb-select-control", { class: `fcis-dropdown ${textIsValid(info) ? 'fcis-dropdown--with-tooltip' : ''}` }, h("wb-select", null, h("label", { class: 'fcis-dropdown__label' }, label), h("select", { id: id, name: id, key: `${id}_${this.renderNumber}`, ref: (e) => (this.selectElement = e), class: 'fcis-dropdown__input', "data-analytics-id": id }, values.map((item) => (h("option", { value: item.value, selected: item.selected, disabled: item.selected }, item.label)))), textIsValid(info) && (h("div", { class: 'fcis-dropdown__tooltip' }, h("fcis-tooltip", { storeId: this.storeId, content: info })))), message && h("wb-control-hint", { innerHTML: escape(message) })));
  }
  static get watchers() { return {
    "input": ["onInputChange"]
  }; }
};
FcisDropdown.style = fcisDropdownCss;

const fcisLabelCss = ".fcis-label{position:relative;margin-top:var(--wb-spacing-xs)}.fcis-label--with-tooltip .fcis-label__input{padding-right:3rem}.fcis-label__tooltip{right:1rem;position:absolute;top:1rem;display:-ms-inline-flexbox;display:inline-flex;-ms-flex-item-align:center;align-self:center}.fcis-label__input-wrapper{overflow:visible}";

const FcisLabel = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  render() {
    const { label, value, message, info, id } = this.input;
    return (h("wb-input-control", { class: `fcis-label ${textIsValid(info) ? 'fcis-label--with-tooltip' : ''}` }, h("wb-input", { class: 'fcis-label__input-wrapper' }, h("label", { class: 'fcis-label__label' }, label), h("input", { class: 'fcis-label__input', type: 'text', readonly: true, value: value.label }), textIsValid(info) && (h("div", { class: 'fcis-label__tooltip' }, h("fcis-tooltip", { storeId: this.storeId, content: info })))), message && h("wb-control-hint", { innerHTML: escape(message) }), h("input", { type: 'hidden', name: id, value: value.value })));
  }
};
FcisLabel.style = fcisLabelCss;

const fcisNumberCss = "fcis-number{display:block}.fcis-number{margin-top:var(--wb-spacing-xs)}.fcis-number__input{-webkit-box-sizing:border-box;box-sizing:border-box;-moz-appearance:textfield}.fcis-number__input::-webkit-inner-spin-button,.fcis-number__input::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.fcis-number__input--hidden{display:none}.fcis-number__input-wrapper{overflow:visible}.fcis-number__tooltip{right:1rem;position:absolute;top:1rem;display:-ms-inline-flexbox;display:inline-flex;-ms-flex-item-align:center;align-self:center}";

const FcisNumber = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.decimalPlaces = DEFAULT_DECIMAL_CASES;
    this.active = false;
    this._toggleEditing = this.toggleEditing.bind(this);
  }
  onBlur() {
    if (this.numberInputElement.value === '') {
      this.numberInputElement.value = this.numberInputElement.min || '0';
    }
    const decimalPlaces = getDecimalPlaces(this.input.value.format);
    const oldRoundedValue = Number(this.numberInputElement.dataset.value).toFixed(decimalPlaces);
    const newRoundedValue = Number(this.numberInputElement.value).toFixed(decimalPlaces);
    if (newRoundedValue !== oldRoundedValue) {
      this.numberInputElement.dataset.value = this.numberInputElement.value;
      this.wrapper.dispatchEvent(new CustomEvent('change', { bubbles: true }));
    }
    this._toggleEditing();
  }
  toggleEditing() {
    const hiddenClass = 'fcis-number__input--hidden';
    this.active = !this.active;
    if (this.active) {
      this.textInputElement.classList.add(hiddenClass);
      this.numberInputElement.classList.remove(hiddenClass);
      this.numberInputElement.focus();
    }
    else {
      this.textInputElement.classList.remove(hiddenClass);
      this.numberInputElement.classList.add(hiddenClass);
    }
  }
  setInputValue() {
    this.numberInputElement.dataset.value = this.input.value.value;
    if (this.numberInputElement) {
      const decimalPlaces = getDecimalPlaces(this.input.value.format);
      this.numberInputElement.value = parseFloat(this.input.value.value).toFixed(decimalPlaces);
    }
  }
  onEnterEvent(event) {
    if (event.key === 'Enter') {
      event.srcElement.blur();
    }
  }
  componentDidLoad() {
    this.setInputValue();
    this.numberInputElement.addEventListener('keydown', this.onEnterEvent);
  }
  componentDidUpdate() {
    this.setInputValue();
  }
  disconnectedCallback() {
    this.numberInputElement.removeEventListener('keydown', this.onEnterEvent);
  }
  render() {
    const { id, info, label, value, step, minValue, maxValue, message } = this.input;
    const staticInput = (h("input", { class: 'fcis-number__input', ref: (el) => (this.textInputElement = el), onFocus: this._toggleEditing, type: 'text', readonly: true, value: value.label }));
    const dynamicInput = (h("input", { class: 'fcis-number__input fcis-number__input--hidden', ref: (el) => (this.numberInputElement = el), type: 'number', id: id, autoFocus: true, name: id, "data-value": value.value, onChange: (e) => e.stopPropagation(), onBlur: this.onBlur.bind(this), step: step || 'any', min: minValue && minValue.value, max: maxValue && maxValue.value, value: '' }));
    return (h(Host, { "data-analytics-id": id }, h("wb-input-control", { class: 'fcis-number' }, h("wb-input", { class: 'fcis-number__input-wrapper' }, h("label", { class: 'fcis-dropdown__label' }, label), dynamicInput, staticInput, textIsValid(info) && (h("div", { class: 'fcis-number__tooltip' }, h("fcis-tooltip", { storeId: this.storeId, content: info })))), message && h("wb-control-hint", { innerHTML: escape(message) }))));
  }
  get wrapper() { return getElement(this); }
};
FcisNumber.style = fcisNumberCss;

export { FcisDropdown as fcis_dropdown, FcisLabel as fcis_label, FcisNumber as fcis_number };
